module.exports = __webpack_public_path__ + "static/img/gameIntroduce_blue.3d52cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameIntroduce_blue.png
// module id = PB/9
// module chunks = 1